"use client";
import React from "react";
import Link from "next/link";
import Button from "./Button";

const DefaultPageComponent: React.FC<{
  image: string;
  text: string;
  className?: string;
  noButton?: boolean;
  append?: React.ReactElement;
  svg: React.FC;
  variant?: boolean;
}> = ({ text, variant, append, className, svg, noButton }) => {
  const Svg = svg;
  return (
    <div className={`py-6  wrapper ${className}`}>
      <div className="items flex relative  justify-center mb-20"></div>
      <div className="">
        <Svg />
      </div>

      <div className="button-items">
        <p className="text-xl mb-20 mx-auto text-center max-w-[880px]">
          {text} {append && append}
          {variant && (
            <>
              <Link
                target="_blank"
                className="text-primary-main"
                href="https://ourproperty.ng/waitlist/"
              >
                Click here
              </Link>
              <span> to stay tuned for updates!.</span>
            </>
          )}
        </p>{" "}
        {!noButton && (
          <div className="button flex justify-center mb-12">
            <Button className="bg-themeColor px-6 !py-2   text-white" href="/">
              Return to Home Page
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default DefaultPageComponent;
